"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableFilters = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const DateRangeFilter_js_1 = require("./DateRangeFilter/DateRangeFilter.js");
const NumberRangeFilter_js_1 = require("./NumberRangeFilter/NumberRangeFilter.js");
const TextFilter_js_1 = require("./TextFilter/TextFilter.js");
exports.tableFilters = {
    /**
     * Basic filter with a single input field.
     * @param translatedLabels Translated filter labels.
     */
    TextFilter: (translatedLabels) => (props) => React.createElement(TextFilter_js_1.TextFilter, { ...props, translatedLabels: translatedLabels }),
    /**
     * Date range filter.
     *
     * By default it handles user input in `en-us` date format. If you want to use other format
     * please provide `formatDate`, `parseInput` and `placeholder`.
     *
     * It only works with `Date` type object properties.
     * If your data is different type e.g. `string`, you can use `accessor` property in column description:
     * `accessor: (rowData) => new Date(rowData.date)`.
     */
    DateRangeFilter: (options) => (props) => React.createElement(DateRangeFilter_js_1.DateRangeFilter, { ...props, ...options }),
    /**
     * Number range filter.
     *
     * It only works with `number` type object properties.
     * If your data is different type e.g. `string`, you can use `accessor` property in column description:
     * `accessor: (rowData) => Number(rowData.numberProp)`.
     * @param translatedLabels Translated filter labels.
     */
    NumberRangeFilter: (translatedLabels) => (props) => React.createElement(NumberRangeFilter_js_1.NumberRangeFilter, { ...props, translatedLabels: translatedLabels }),
};
